import unary from "./unary";

// String -> Error
const toError = unary(Error);

export default toError;
